// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"464":"bce2c006","592":"3122a047"}[chunkId] + ".chunk.js";
};